/**
 * BR 公司显示名：Summary → fallback → 登录用户（按语言）统一回退。
 * 管理端代传时勿传 user，避免回退到管理员账号公司名。
 */

function pickSummaryField(summary, camelKey, pascalKey) {
  const row = summary || {};
  return String(row[camelKey] || row[pascalKey] || '').trim();
}

/** 空或占位符「—」视为无效显示名 */
export function isBrPlaceholderName(value) {
  const text = String(value || '').trim();
  return !text || text === '—';
}

/**
 * @param {{ summary?: object, user?: object|null, fallback?: string, emptyFallback?: string }} options
 */
export function resolveBrCompanyNameEn({
  summary,
  user = null,
  fallback = '',
  emptyFallback = '',
} = {}) {
  const fromSummary = pickSummaryField(summary, 'currentNameEn', 'CurrentNameEn');
  if (fromSummary) {
    return fromSummary;
  }
  const fromFallback = String(fallback || '').trim();
  if (!isBrPlaceholderName(fromFallback)) {
    return fromFallback;
  }
  if (user) {
    const fromUser = String(user.companyNameEn || '').trim();
    if (fromUser) {
      return fromUser;
    }
  }
  return emptyFallback;
}

/**
 * @param {{ summary?: object, user?: object|null, langId?: string|number, fallback?: string, emptyFallback?: string }} options
 */
export function resolveBrCompanyNameZh({
  summary,
  user = null,
  langId,
  fallback = '',
  emptyFallback = '',
} = {}) {
  const fromSummary = pickSummaryField(summary, 'currentNameZh', 'CurrentNameZh');
  if (fromSummary) {
    return fromSummary;
  }
  const fromFallback = String(fallback || '').trim();
  if (!isBrPlaceholderName(fromFallback)) {
    return fromFallback;
  }
  if (!user) {
    return emptyFallback;
  }
  const id = String(langId ?? '');
  if (id === '1252') {
    return String(user.companyNameSc || user.companyNameTc || '').trim() || emptyFallback;
  }
  if (id === '936') {
    return String(user.companyNameSc || '').trim() || emptyFallback;
  }
  return String(user.companyNameTc || user.companyNameSc || '').trim() || emptyFallback;
}
